import React from "react";
import styles from "./SculpturesSection.module.scss";
import ArtworkCard from "components/cards/artworkCard/ArtworkCard";
import Title from "components/title/Title";
import { sculptures } from "mockdata/sculptures";

const SculpturesSection = () => {
  return (
    <div className={styles.sculpturesSectionContainer}>
      <div className="container">
        <Title text={"Sculptures"} bottomStrokeWidth={"59%"} />
        <div className={styles.seeAllWrapper}>
          <div className={styles.seeAll}>See All Sculptures</div>
        </div>
        <div className={styles.cardGrid}>
          {sculptures.map((sculpture) => {
            return <ArtworkCard item={sculpture} key={sculpture.id} />;
          })}
        </div>
        <div className={styles.seeAllCentered}>See All Sculptures</div>
      </div>
    </div>
  );
};

export default SculpturesSection;
